import { render, staticRenderFns } from "./editTalqahOrderModal.vue?vue&type=template&id=b8a671ea&"
import script from "./editTalqahOrderModal.vue?vue&type=script&lang=js&"
export * from "./editTalqahOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports